import SBlog from "./SBlog_web"
export default SBlog
